import { useAppDispatch } from '@core/configureStore';
import {
  ActionReducerMapBuilder,
  AsyncThunk,
  AsyncThunkAction,
  CaseReducers,
} from '@reduxjs/toolkit';

export const getSideEffectState = <R, A>(thunk: AsyncThunk<R, A, any>) => {
  return [thunk.fulfilled.toString(), thunk.pending.toString(), thunk.rejected.toString()];
};

export const useAppBatchDispatch = () => {
  const dispatch = useAppDispatch();
  return async (calls: (() => AsyncThunkAction<any, void, any>)[]) => {
    for (const call of calls) {
      await dispatch(call());
    }
  };
};

export type ExtraReducer<T> =
  | CaseReducers<T, any>
  | ((builder: ActionReducerMapBuilder<T>) => void)
  | undefined;
